import React, { useEffect, useState } from "react";

import Home from "./Home";
import AboutUs from "./AboutUs";
import Slide from "./Slide";
import Ages from "./Ages";
import News from "./News";
import Happy from "./Happy";
import Come from "./Come";
import dots from "../Assets/dots.svg";
import { Helmet } from "react-helmet";

const Main = () => {
  const [dotPosition, setDotPosition] = useState(100); // Initial position
  const [showDots, setShowDots] = useState(false); // Show/hide dots

  useEffect(() => {
    const handleScroll = () => {
      const homeElement = document.getElementById("home");
      const aboutUsElement = document.getElementById("aboutUs");

      const scrollPosition = window.scrollY;
      const homeBottom = homeElement.offsetTop + homeElement.offsetHeight;
      const aboutUsBottom = aboutUsElement.offsetTop + aboutUsElement.offsetHeight;


      if (scrollPosition >= homeElement.offsetTop && scrollPosition < aboutUsBottom) {
        setShowDots(true);
        // Move dots dynamically within this range
        setDotPosition(Math.min(scrollPosition, aboutUsElement.offsetTop));
      } else {
        setShowDots(false); // Hide dots when out of range
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>Kindergarten Play School & Day Care in Vellore | Kalam Kids</title>
        <meta
          name="description"
          content="Best Kindergarten Preschool in Vellore offers Kids Daycare, Nursery, Pre-KG, LKG, UKG & Playgroup Montessori Method Programs designed to nurture early childhood."
        />
      </Helmet>

      {/* Dots */}
      {showDots && (
        <img
          src={dots}
          alt="dots"
          style={{
            position: "fixed",
            top: `${dotPosition - -90}px`,
            left: "30%",
            zIndex: 40,
            height: "50%"
          }}
        />
      )}

      {/* Sections */}
      <div id="home">
        <Home />
      </div>
      <div id="aboutUs">
        <AboutUs />
      </div>
      <Slide />
      <Ages />
      <Come />
      <News />
      <Happy />

    </>
  );
};

export default Main;
